import { genericStringValidator } from "../../../utils/validators";
import { getOptionalMinLengthTest } from "../getOptionalMinLengthTest";

export function getValidatorAddressStreet(includePOBox?: boolean) {
  const validator = genericStringValidator
    .matches(new RegExp("^[ a-zA-Z0-9\u00C0-\u017F'\\#’.,:;()?&*-/]+$"), {
      excludeEmptyString: true,
      message:
        "May contain only characters: a-z, A-Z, 0-9, #, ', ., &, -, inner spaces and accented characters"
    })
    .test(testMinLengthIfNotEmpty);

  if (includePOBox) {
    return validator;
  }

  return validator.test(testNoPOBox);
}

const VALIDATOR_ADDRESS_MIN_LENGTH = 4;
const VALIDATOR_ADDRESS_MIN_LENGTH_ERROR = `Address should have at least ${VALIDATOR_ADDRESS_MIN_LENGTH} characters.`;

const testMinLengthIfNotEmpty = getOptionalMinLengthTest(
  VALIDATOR_ADDRESS_MIN_LENGTH,
  VALIDATOR_ADDRESS_MIN_LENGTH_ERROR
);

const REGEX_PO_BOX = /\b(p[\s.]*o|post\s+office)[\s.]*(?:box|\d)/i;
const testNoPOBox = {
  name: "No PO Box",
  message: "PO Boxes are not supported",
  test: (value?: string) => !REGEX_PO_BOX.test(value || "")
};
